module.exports = __webpack_public_path__ + "media/images/srfLogo-b751973ced626d7c29067845ef3bd838.png";